import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./Login";
import Signup from "./Signup";

const Navbar = () => {
  const state = useSelector((state) => state.hanldeCart);

  const handleClick = () => {
      document.querySelectorAll(".nav-link").forEach((el) => {
        el.addEventListener("click", () => {
          document.querySelector(".navbar-toggler").click();
        });
      });
  }

  return (
    <div>
      <nav className="navbar navbar-expand-lg fixed-top bg-white navbar-light py-3 shadow-sm">
        <div className="container">
          <NavLink className="navbar-brand fw-bold fs-3" to="#">
            E-Mart
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link active" aria-current="page" onClick={handleClick} to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={handleClick} to="/products">
                  Products
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={handleClick} to="/about">
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" onClick={handleClick} to="/contact">
                  Contact
                </NavLink>
              </li>
            </ul>
            <div className="buttons">
              <Login />
              <Signup />
              <NavLink to="/cart" className="btn btn-outline-dark ms-2">
                <i className="fa fa-shopping-cart me-1"></i> Cart (
                {state.length})
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
